import { ReactElement } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { BillingOverview } from "~/pages/Billing/ClientOverview";
import { User } from "~/types/user";
import { isBillingUser, getRedirectPath } from "~/utils/userRoles";
import { ClientBillingOverview } from "./ClientSpecificView/ClientBillingOverview";
import { BillingDateProvider } from "./contexts/BillingDateContext";
import { billingPageWrapper } from "./styles_vanilla.css";

interface Props {
  currentUser: User;
}

export const Billing = ({ currentUser }: Props): ReactElement => {
  if (!isBillingUser(currentUser.roles)) {
    return <Redirect to={getRedirectPath(currentUser)} />;
  }

  return (
    <div className={billingPageWrapper} data-billing-module data-testid="billing-module">
      <BillingDateProvider>
        <Switch>
          <Route path="/billing/client/:clientId">
            <ClientBillingOverview />
          </Route>
          <Route path="/billing">
            <BillingOverview />
          </Route>
        </Switch>
      </BillingDateProvider>
    </div>
  );
};
